module.exports = __webpack_public_path__ + "img/1.a4a14155.jpg";